import { InventoryCountUpdatePage } from "@/features/inventory-count/pages/InventoryCountUpdatePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/inventory-count/$id/update")({
  component: InventoryCountUpdatePage,
});
